import _get from 'lodash/get';
import { FormCategory } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import FormTemplateCategoryFieldNames from '@lib/enums/fieldNames/formTemplateCategoryFieldNames';

export function getDefaultValuesFromQueryData(data?: FormCategory): Values {
  return {
    [FormTemplateCategoryFieldNames.Id]: _get(data, 'id', null),
    [FormTemplateCategoryFieldNames.Name]: _get(data, 'name', null),
    [FormTemplateCategoryFieldNames.Color]: data?.color
      ? { value: data.color }
      : null,
  };
}
